"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var cookie_exports = {};
__export(cookie_exports, {
  getCookie: () => getCookie,
  getCurrentDomain: () => getCurrentDomain,
  setCookie: () => setCookie
});
module.exports = __toCommonJS(cookie_exports);
const getCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(?:^| )${name}=([^;]+)`));
  return match ? match[1] : null;
};
const getCurrentDomain = () => {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    const hostname = window.location.hostname;
    if (hostname === "localhost") {
      return hostname;
    }
    if (hostname.includes("checkatrade-consumer-web.pages.dev")) {
      return hostname;
    }
    if (hostname.includes("checkatrade.com")) {
      return hostname;
    }
    return null;
  } catch (error) {
    console.warn("Failed to get current domain:", error);
    return null;
  }
};
const setCookie = (name, value, options) => {
  let cookie = `${name}=${value}; path=/`;
  if (typeof options.maxAgeSeconds !== "undefined") {
    cookie += `; max-age=${options.maxAgeSeconds}`;
  }
  if (typeof options.domain !== "undefined") {
    cookie += `; domain=${options.domain}`;
  }
  document.cookie = `${cookie};`;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  getCookie,
  getCurrentDomain,
  setCookie
});
